import { ReactElement } from 'react';

import { ManageProfile } from './ManageProfile';
import { Drawer } from '@/components';
import { useEditUserForm } from '../hooks';
import { FormProvider } from 'react-hook-form';
import { ManageProfileTitle } from './ManageProfileTitle';
import { ManageProfileActions } from './ManageProfileActions';

type ManageProfileDrawerProps = {
  value: boolean;
  setFalse: () => void;
};

export const ManageProfileDrawer = (
  props: ManageProfileDrawerProps,
): ReactElement => {
  const form = useEditUserForm();
  const { value, setFalse } = props;

  return (
    <FormProvider {...form}>
      <Drawer
        open={value}
        onClose={setFalse}
        title={<ManageProfileTitle />}
        content={<ManageProfile />}
        actions={<ManageProfileActions onClose={setFalse} />}
      />
    </FormProvider>
  );
};
